import React from 'react';

import PoweredByStripe from 'icons/PoweredByStripe';

import styled from 'styled-components/macro';
import { baseSpacing, transition } from 'css/constants';

const link = {
  url: 'http://stripe.com',
  alt: 'Stripe logo',
  title: 'Visit stripe.com'
};

const StripeLinkWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${baseSpacing / 2}px;

  a {
    opacity: 0.8;
    transition: ${transition};

    &:hover,
    &:focus,
    &:active {
      opacity: 1;
    }
  }
`;

const StripeLink = () => (
  <StripeLinkWrapper>
    <div>
      <a
        href={link.url}
        rel="noopener noreferrer"
        target="_blank"
        title={link.title}
      >
        <PoweredByStripe />
      </a>
    </div>
  </StripeLinkWrapper>
);

export default StripeLink;
